import { baseAxiosInstance } from '../instances/BaseAxiosInstance';

interface UserOnboardResponse {
    id: string;
    email: string;
    phone?: string;
    firstname?: string;
    lastname?: string;
    loginTimes?: number;
    mailSettings: {
        newsletter: boolean;
        transactional: boolean;
    };
}

export interface UserOnboardErrorResponse {
    errorCode: 'NOT_ALLOWED';
}

export interface UserOnboardRequest extends UserOnboardResponse {
    password: string;
}

export interface UserOnboardRequestErrorResponse {
    errorCode: 'MAIL_NOT_UNIQUE' | 'PASSWORD_SAFETY';
    message?: string;
}

export const getOnboardingUser = async (userId: string, token: string): Promise<UserOnboardResponse> => {
    const response = await baseAxiosInstance.get(`/v1/user/onboarding`, {
        params: {
            userId,
            token,
        },
    });

    return response.data;
};

export const updateOnboardingUser = async (
    userId: string,
    token: string,
    user: UserOnboardRequest
): Promise<UserOnboardResponse> => {
    const response = await baseAxiosInstance.put<UserOnboardResponse>(`/v1/user/onboarding`, user, {
        params: {
            userId,
            token,
        },
    });

    return response.data;
};
